export const STATUT_VALIDE = 2;
export const STATUT_NON_VISE = 1;
export const STATUT_REFUSE = 0;